// Deep links into the Stripe dashboard for the Outclose account. Kept in one
// place so every admin surface points at the same account.
export const STRIPE_ACCOUNT_ID = 'acct_1S3ap4PbcqTyHuTe';

const STRIPE_DASHBOARD = `https://dashboard.stripe.com/${STRIPE_ACCOUNT_ID}`;

/** Customer profile page in the Stripe dashboard. */
export function stripeCustomerUrl(stripeCustomerId: string): string {
  return `${STRIPE_DASHBOARD}/customers/${encodeURIComponent(stripeCustomerId)}`;
}

/** Customer balance transactions (credits / referral rewards). */
export function stripeCustomerBalanceUrl(stripeCustomerId: string): string {
  return `${stripeCustomerUrl(stripeCustomerId)}/balance_transactions`;
}
